import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  submit(event) {
    if (event.target.type !== 'radio' || event.target.form !== this.element) {
      return;
    }

    const group = event.target.closest('.radio-submit-buttons');
    if (group) {
      // A group may mix radio names (products index), so the browser won't uncheck the others.
      this.uncheckRadios(group, event.target);
      this.activate(group, event.target.closest('label'));
    }

    this.element.requestSubmit();
  }

  clear(event) {
    const group = event.currentTarget.closest('.radio-submit-buttons');
    if (group) {
      this.uncheckRadios(group);
      this.activate(group, event.currentTarget);
    }

    this.element.requestSubmit();
  }

  uncheckRadios(group, except) {
    group.querySelectorAll('input[type="radio"]').forEach((radio) => {
      if (radio !== except) radio.checked = false;
    });
  }

  activate(group, button) {
    group.querySelectorAll('.active').forEach((element) => {
      element.classList.remove('active');
    });
    button?.classList.add('active');
  }
}
